/*
  V1C P1: behaviour for templates/product.v1-polo-full-price.json only.
  Loaded (defer) from snippets/v1-polo-assets.liquid. theme.js is not modified.

  Gallery (theme: <slide-with-thumbs> in snippets/media-gallery.liquid, Swipers in theme.js
  SlideWithThumbs, exposed as el.globalSlide / el.thumbnailSlide):
  - Mobile (<=767px): slidesPerView 'auto' + 10px gap (slides are 330px wide in v1-polo.css), dots.
  - Try-on video slide (snippets/v1-tryon-slide.liquid) stays first. On a colour change,
    theme.js updateMediaGroup() replaces the whole <slide-with-thumbs> via innerHTML and its
    .finally() jumps to slide 0. We wait until after .finally (slide 0 = the colour's first photo,
    already on screen), then in one go re-insert the video slide + thumbnail in front and stay on
    that photo (index 1), so the video poster is never painted (P4 0.23).
  - Each colour's first photo is preloaded once the page is idle (P4 0.23).
  - Video plays only while its slide is active and on screen.
*/
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767px)');
  var templates = { main: null, thumb: null };

  function swiperReady(el, cb, tries) {
    tries = tries || 0;
    if (el.globalSlide) return cb();
    if (tries > 100) return;
    setTimeout(function () {
      swiperReady(el, cb, tries + 1);
    }, 50);
  }

  /* ---------- Swiper params ---------- */

  function applyLayout(el) {
    var main = el.globalSlide;
    if (!main) return;
    if (!el._v1Original) {
      el._v1Original = { slidesPerView: main.params.slidesPerView, spaceBetween: main.params.spaceBetween };
    }
    if (MOBILE.matches) {
      main.params.slidesPerView = 'auto';
      main.params.spaceBetween = 10;
    } else {
      main.params.slidesPerView = el._v1Original.slidesPerView;
      main.params.spaceBetween = el._v1Original.spaceBetween;
    }
    main.update();
    var thumbs = el.thumbnailSlide;
    if (thumbs) {
      thumbs.params.spaceBetween = 10;
      thumbs.params.slidesPerView = 7;
      if (thumbs.params.breakpoints && thumbs.params.breakpoints[768]) {
        thumbs.params.breakpoints[768].slidesPerView = 7;
      }
      thumbs.update();
    }
  }

  /* ---------- Video slide ---------- */

  function ensureVideoSlides(el) {
    var mainWrapper = el.querySelector('.media-main-swiper .swiper-wrapper');
    var thumbWrapper = el.querySelector('.thumbnail-slide .swiper-wrapper');
    var inserted = false;

    if (mainWrapper) {
      var mainSlide = mainWrapper.querySelector('[data-v1-tryon="main"]');
      if (mainSlide && !templates.main) templates.main = mainSlide.cloneNode(true);
      if (!mainSlide && templates.main) {
        mainWrapper.insertBefore(templates.main.cloneNode(true), mainWrapper.firstChild);
        inserted = true;
      }
    }
    if (thumbWrapper) {
      var thumbSlide = thumbWrapper.querySelector('[data-v1-tryon="thumb"]');
      if (thumbSlide && !templates.thumb) templates.thumb = thumbSlide.cloneNode(true);
      if (!thumbSlide && templates.thumb) {
        thumbWrapper.insertBefore(templates.thumb.cloneNode(true), thumbWrapper.firstChild);
        inserted = true;
      }
    }
    return inserted;
  }

  function videoState(el) {
    var main = el.globalSlide;
    var slide = el.querySelector('[data-v1-tryon="main"]');
    var video = slide && slide.querySelector('video');
    if (!main || !video) return;
    var active = main.slides[main.activeIndex] === slide;
    if (active && el._v1VideoVisible && !document.hidden) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      video.pause();
    }
  }

  function watchVideo(el) {
    var video = el.querySelector('[data-v1-tryon="main"] video');
    if (!video) return;
    video.muted = true; // required for autoplay; set as a property too (some browsers ignore the attribute on clones)
    el._v1VideoVisible = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          el._v1VideoVisible = entries[0].isIntersecting;
          videoState(el);
        },
        { threshold: 0.5 }
      ).observe(video);
    } else {
      el._v1VideoVisible = true;
    }
    // theme.js pauses every <video> on slideChange; restart ours when its slide is active again
    el.globalSlide.on('slideChangeTransitionEnd', function () {
      videoState(el);
    });
    el.globalSlide.on('slideChange', function () {
      videoState(el);
    });
  }

  /* ---------- Dots (mobile) ---------- */

  // Batch 8: no dots (Fabrice). Kept as a switch; the theme's "x/y" counter stays hidden in CSS.
  var SHOW_DOTS = false;

  function renderDots(el) {
    if (!SHOW_DOTS) return;
    var main = el.globalSlide;
    if (!main) return;
    var dots = el.querySelector('.v1-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'v1-dots';
      dots.setAttribute('aria-hidden', 'true');
      var mainBox = el.querySelector('.media-main-swiper');
      mainBox.parentNode.insertBefore(dots, mainBox.nextSibling);
    }
    var count = main.slides.length;
    if (dots.children.length !== count) {
      dots.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('span');
        dot.className = 'v1-dot';
        dots.appendChild(dot);
      }
    }
    for (var j = 0; j < dots.children.length; j++) {
      dots.children[j].classList.toggle('is-active', j === main.activeIndex);
    }
  }

  /* ---------- Per gallery instance ---------- */

  function enhance(el, isRebuild) {
    if (el._v1Enhanced) return;
    el._v1Enhanced = true;
    // P4 0.23: on a rebuild (colour change) the video slide is NOT put back here. If it were, theme.js's
    // .finally() goTo(0) would land on it and its poster would flash before the colour's photos.
    var inserted = isRebuild ? false : ensureVideoSlides(el);
    swiperReady(el, function () {
      applyLayout(el);
      if (inserted && el.thumbnailSlide) el.thumbnailSlide.update();
      renderDots(el);
      el.globalSlide.on('slideChange', function () {
        renderDots(el);
      });
      el.globalSlide.on('update', function () {
        renderDots(el);
      });
      if (isRebuild) {
        // Runs after theme.js .finally() (goTo 0 = the colour's first photo, already on screen).
        // In one task, so nothing is painted in between: put the video slide back in front, refresh
        // both Swipers and stay on that same photo (now index 1).
        setTimeout(function () {
          var main = el.globalSlide;
          var added = ensureVideoSlides(el);
          if (main) {
            if (added) {
              main.update();
              if (el.thumbnailSlide) el.thumbnailSlide.update();
            }
            var target = el.querySelector('[data-v1-tryon="main"]') ? 1 : 0;
            // runCallbacks=false: no slideChange → theme.js does not call pauseAllMedia(), which
            // would abort PageFly's pending video play() further down the page (uncaught AbortError).
            main.slideTo(target, 0, false);
            if (main.thumbs && main.thumbs.update) main.thumbs.update(true);
          }
          watchVideo(el);
          renderDots(el);
          videoState(el);
        }, 0);
      } else {
        watchVideo(el);
        videoState(el);
      }
    });
  }

  function init() {
    var section = document.querySelector('.product__item-js');
    if (!section) return;
    var gallery = section.querySelector('media-gallery');
    if (!gallery) return;
    var first = gallery.querySelector('slide-with-thumbs');
    if (first) enhance(first, false);

    // Colour change: theme.js replaces <slide-with-thumbs> inside <zoom-action>.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var el = node.matches('slide-with-thumbs') ? node : node.querySelector && node.querySelector('slide-with-thumbs');
          if (el) enhance(el, true);
        });
      });
    }).observe(gallery, { childList: true, subtree: true });

    var onBreakpoint = function () {
      var el = gallery.querySelector('slide-with-thumbs');
      if (el) applyLayout(el);
    };
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', onBreakpoint);
    document.addEventListener('visibilitychange', function () {
      var el = gallery.querySelector('slide-with-thumbs');
      if (el) videoState(el);
    });

    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 2000); };
    idle(function () {
      preloadColourPhotos(section);
    });
  }

  /* ---------- Preload (P4 0.23) ---------- */

  // Once the page is idle, download each colour's first photo, so a colour change never shows an empty
  // slot while that photo loads. Same request theme.js makes on a colour change (section
  // media-gallery-slide); srcset + sizes are copied from its <img>, so the browser picks the same file
  // it will show later (then served from cache). Skipped when the visitor asks to save data.
  function preloadColourPhotos(section) {
    if (navigator.connection && navigator.connection.saveData) return;
    var picker = section.querySelector('[data-product-handle]');
    var handle = picker && picker.dataset.productHandle;
    if (!handle || !window.fetch || !window.DOMParser) return;
    fetch('/products/' + handle + '?section_id=media-gallery-slide')
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var done = {};
        html
          .querySelectorAll('a.media-gallery__image[data-alt], div.media-gallery__image[data-pane-container][data-alt]')
          .forEach(function (item) {
            var alt = item.getAttribute('data-alt');
            var img = item.querySelector('img');
            if (!alt || done[alt] || !img) return;
            done[alt] = true;
            var pre = new Image();
            if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
            if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
            pre.src = img.getAttribute('src');
          });
      })
      .catch(function () {});
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('slide-with-thumbs').then(function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
      else init();
    });
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/*
  Buy box (batch 5): no size preselected, button labels, submit guard, sticky bar.
  Without ?variant=, the Liquid renders a checked+disabled placeholder radio in the Size fieldset
  (.v1-size-none) so theme.js always finds a checked radio (its updateVariantStatuses() throws
  otherwise). theme.js then sees "no variant": it disables the button, writes "Unavailable" and hides
  the price. This script runs after theme.js's change handler and sets the real state.
*/
(function () {
  'use strict';

  // Labels come from the V1 Size extras block settings, rendered as data-v1-select-label /
  // data-v1-add-label on the add-to-cart buttons (snippets/buy-buttons.liquid). No UI text here.
  var LABEL_SELECT = null;
  var LABEL_ADD = null;

  function init() {
    var section = document.querySelector('.product__item-js');
    if (!section) return;
    var picker = section.querySelector(
      '.product-detail__information variant-group-detail, .product-detail__information variant-radios-detail'
    );
    if (!picker) return;
    var fieldsets = [].slice.call(picker.querySelectorAll('fieldset.product-form__input'));
    var sizeFieldset = picker.querySelector('fieldset.product-form__input:not(.product-form__input_color)');
    var colourFieldset = picker.querySelector('fieldset.product-form__input_color');
    var jsonEl = picker.querySelector('script[type="application/json"]');
    if (!sizeFieldset || !jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var sizeIndex = fieldsets.indexOf(sizeFieldset);
    var colourIndex = colourFieldset ? fieldsets.indexOf(colourFieldset) : -1;
    var sizeName = (sizeFieldset.querySelector('input[type="radio"]') || {}).name;
    var sectionId = picker.dataset.section;
    var forms = [].slice.call(section.querySelectorAll('form[action*="/cart/add"]'));
    var buttons = forms
      .map(function (f) {
        return f.querySelector('[name="add"]');
      })
      .filter(Boolean);
    var labelled = buttons.filter(function (b) {
      return b.dataset.v1SelectLabel || b.dataset.v1AddLabel;
    })[0];
    if (labelled) {
      LABEL_SELECT = labelled.dataset.v1SelectLabel || null;
      LABEL_ADD = labelled.dataset.v1AddLabel || null;
    }
    var price = document.getElementById('price-' + sectionId);
    var stickyPrice = section.querySelector('.v1-sticky-price');

    function realSizeInputs() {
      return [].slice.call(sizeFieldset.querySelectorAll('input[type="radio"]:not(.v1-size-none)'));
    }
    function checkedSize() {
      var r = sizeFieldset.querySelector('input[type="radio"]:checked:not(.v1-size-none)');
      return r ? r.value : null;
    }
    function checkedColour() {
      var r = colourFieldset && colourFieldset.querySelector('input[type="radio"]:checked');
      return r ? r.value : null;
    }
    function findVariant(size, colour) {
      return variants.find(function (v) {
        return v.options[sizeIndex] === size && (colourIndex < 0 || v.options[colourIndex] === colour);
      });
    }
    function clearSize() {
      var none = sizeFieldset.querySelector('.v1-size-none');
      if (none) none.checked = true;
      else
        realSizeInputs().forEach(function (r) {
          r.checked = false;
        });
    }
    function stripVariantFromUrl() {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('variant')) return;
      url.searchParams.delete('variant');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
    function setButtons(label, enabled) {
      buttons.forEach(function (b) {
        if (!label) {
          if (enabled) b.removeAttribute('disabled');
          return; // no label configured: keep the text rendered by Liquid
        }
        var span = b.querySelector('.btn-label') || b.querySelector('span');
        if (span && span.textContent.trim() !== label) span.textContent = label;
        if (enabled) b.removeAttribute('disabled');
      });
    }
    function updateAvailability(colour) {
      // Sizes: against the selected colour. Colours: available if any size is
      // (a size missing in the new colour is cleared instead of blocking the colour).
      realSizeInputs().forEach(function (r) {
        var v = findVariant(r.value, colour);
        r.classList.toggle('option-disabled', !(v && v.available));
      });
      if (colourFieldset) {
        [].forEach.call(colourFieldset.querySelectorAll('input[type="radio"]'), function (r) {
          var any = variants.some(function (v) {
            return v.options[colourIndex] === r.value && v.available;
          });
          r.classList.toggle('option-disabled', !any);
        });
      }
    }

    function sync(changedName) {
      var colour = checkedColour();
      var size = checkedSize();
      var variant = size ? findVariant(size, colour) : null;

      // Size picked, then the colour changed to a combination that is missing or sold out: clear the size.
      if (size && changedName && changedName !== sizeName && !(variant && variant.available)) {
        clearSize();
        size = null;
        variant = null;
      }
      updateAvailability(colour);

      var sizeValue = sizeFieldset.querySelector('.option_value');
      if (!size) {
        forms.forEach(function (f) {
          var id = f.querySelector('input[name="id"]');
          if (id) id.value = '';
        });
        if (sizeValue && LABEL_SELECT) sizeValue.textContent = LABEL_SELECT;
        if (price) price.classList.remove('hidden');
        stripVariantFromUrl();
        setButtons(LABEL_SELECT, true);
        section.classList.add('v1-no-size');
      } else {
        section.classList.remove('v1-no-size');
        if (sizeValue) sizeValue.textContent = size;
        if (variant && variant.available) {
          forms.forEach(function (f) {
            var id = f.querySelector('input[name="id"]');
            if (id) id.value = variant.id;
          });
          setButtons(LABEL_ADD, true);
        }
        // Sold-out variant (only reachable via ?variant=): keep the theme's sold-out state.
      }
      if (stickyPrice && price) {
        var main = price.querySelector('.price');
        if (main && main.textContent.trim()) stickyPrice.textContent = main.textContent.trim();
      }
    }

    function goToSizes() {
      var top = sizeFieldset.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      sizeFieldset.classList.remove('v1-attn');
      void sizeFieldset.offsetWidth; // restart the highlight animation
      sizeFieldset.classList.add('v1-attn');
      setTimeout(function () {
        sizeFieldset.classList.remove('v1-attn');
      }, 1600);
    }

    // Runs after theme.js's own change handler on the same element (registered earlier, in its constructor).
    picker.addEventListener('change', function (e) {
      var name = e.target && e.target.name;
      sync(name);
      // theme.js can rewrite the button text afterwards (price/media updates): settle once more.
      setTimeout(function () {
        sync();
      }, 0);
    });

    // No size: the button scrolls to the sizes and never submits (capture phase, before theme/app handlers).
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('button[name="add"]');
        if (!btn || buttons.indexOf(btn) < 0 || checkedSize()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        goToSizes();
      },
      true
    );
    document.addEventListener(
      'submit',
      function (e) {
        if (forms.indexOf(e.target) < 0 || checkedSize()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        goToSizes();
      },
      true
    );

    sync();
  }

  function start() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('variant-group-detail').then(start);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/*
  Size guide (batch 6): the "Size guide" button (snippets/v1-size-extras.liquid) moves onto the
  "Size: …" label line and opens its <dialog>. Closes on the close button, Esc (native) and a click
  outside the panel; the page behind does not scroll while it is open.
  Any link to #v1-size-guide (P2 FAQ answers) opens the same dialog; focus returns to that link on close.
*/
(function () {
  'use strict';

  function lockScroll(lock) {
    var root = document.documentElement;
    if (lock) {
      root.dataset.v1ScrollY = String(window.scrollY);
      root.classList.add('v1-scroll-lock');
    } else {
      root.classList.remove('v1-scroll-lock');
    }
  }

  function init() {
    var section = document.querySelector('.product__item-js');
    if (!section) return;
    var link = section.querySelector('.v1-size-guide-link');
    if (!link) return;
    var dialog = document.getElementById(link.getAttribute('aria-controls'));
    if (!dialog || typeof dialog.showModal !== 'function') return;

    // Onto the "Size: …" label line (right side). Not an .option_value: theme.js fills those by index.
    var sizeLabel = section.querySelector(
      '.product-detail__information fieldset.product-form__input:not(.product-form__input_color) .form__label'
    );
    if (sizeLabel) sizeLabel.appendChild(link);

    // The dialog must not stay inside a transformed/sticky ancestor.
    document.body.appendChild(dialog);

    // Tables scroll sideways inside the panel when they don't fit; a fade on the right edge shows
    // while columns are hidden and disappears at the end of the scroll (assets/v1-polo.css).
    var faders = [];
    [].forEach.call(dialog.querySelectorAll('.v1-dialog__body table'), function (table) {
      var wrap = document.createElement('div');
      wrap.className = 'v1-sg-wrap';
      var scroller = document.createElement('div');
      scroller.className = 'v1-sg-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(scroller);
      scroller.appendChild(table);
      var update = function () {
        wrap.classList.toggle('has-more', scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 1);
      };
      scroller.addEventListener('scroll', update, { passive: true });
      faders.push(update);
    });
    function updateFaders() {
      faders.forEach(function (fn) {
        fn();
      });
    }
    window.addEventListener('resize', updateFaders);

    var opener = link;
    function open(from) {
      opener = from || link;
      dialog.showModal();
      lockScroll(true);
      requestAnimationFrame(updateFaders); // sizes are only known once the dialog is open
    }
    link.addEventListener('click', function () {
      open(link);
    });
    // Any link to #v1-size-guide (e.g. in the P2 FAQ answers) opens this pop-up instead of jumping.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#v1-size-guide"]');
      if (!a) return;
      e.preventDefault();
      open(a);
    });
    dialog.querySelector('.v1-dialog__close').addEventListener('click', function () {
      dialog.close();
    });
    // Outside click: the click lands on the <dialog> itself (its backdrop area), not on the panel.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      lockScroll(false);
      opener.focus({ preventScroll: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  P2 "How it's cut" (sections/v1-p2-how-its-cut.liquid): on mobile the dots follow the swipe row.
  One capture-phase scroll listener on the document, so sections re-rendered by the theme editor
  need no re-init. Active dot = the card nearest the row's left edge; the last dot once scrolled to the end.
*/
(function () {
  'use strict';

  function update(row) {
    var dots = row.parentElement.querySelectorAll('.v1-cut__dot');
    var cards = row.children;
    if (!dots.length || !cards.length) return;
    var index;
    if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 2) {
      index = cards.length - 1;
    } else {
      var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : row.clientWidth;
      index = Math.round(row.scrollLeft / step);
    }
    index = Math.max(0, Math.min(index, dots.length - 1));
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('v1-cut__dot--active', i === index);
  }

  var pending = null;
  document.addEventListener(
    'scroll',
    function (e) {
      var row = e.target;
      if (!row.matches || !row.matches('[data-v1-cut-cards]')) return;
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        update(row);
      });
    },
    true
  );
})();

/*
  P2 "What customers say" (sections/v1-p2-reviews.liquid) and the Loox app section on the same page.
  data-v1-reviews-open on .v1-rev (section setting "Show all reviews open"):
  - "true": the Loox section stays expanded (no button is rendered).
  - "false": the Loox section starts collapsed (.v1-loox-collapsed, assets/v1-p2.css); "Read all reviews"
    reveals it, lets Loox re-measure its iframe, and scrolls to it.
  The Loox section is the first Loox widget after the reviews section, else the first one on the page, so
  any section order works. Without JS nothing is collapsed and the button is a plain #looxReviews link.
  Re-applied on shopify:section:load so toggling the setting in the theme editor takes effect.
*/
(function () {
  'use strict';

  // The Loox widget's theme section wrapper: first one after the reviews section, else the first on the page.
  function looxSection(rev) {
    var widgets = document.querySelectorAll('#looxReviews, .loox-widget');
    if (!widgets.length) return null;
    var pick = widgets[0];
    for (var i = 0; i < widgets.length; i++) {
      if (rev.compareDocumentPosition(widgets[i]) & Node.DOCUMENT_POSITION_FOLLOWING) {
        pick = widgets[i];
        break;
      }
    }
    return pick.closest('.shopify-section') || pick;
  }

  function open(target, scroll) {
    target.classList.remove('v1-loox-collapsed');
    target.classList.add('v1-loox-open');
    window.dispatchEvent(new Event('resize'));
    if (!scroll) return;
    requestAnimationFrame(function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function setup(rev) {
    var target = looxSection(rev);
    if (!target) return;
    if (rev.getAttribute('data-v1-reviews-open') !== 'false') {
      if (target.classList.contains('v1-loox-collapsed')) open(target, false);
      return;
    }
    var button = rev.querySelector('[data-v1-loox-open]');
    if (!button) return;
    if (!target.classList.contains('v1-loox-open')) target.classList.add('v1-loox-collapsed');
    if (button.dataset.v1Bound) return;
    button.dataset.v1Bound = '1';
    button.addEventListener('click', function (e) {
      e.preventDefault();
      open(target, true);
    });
  }

  function init() {
    document.querySelectorAll('.v1-rev').forEach(setup);
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
